import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  item: {
    padding: '1rem 1.5rem 1rem 2.5rem',
    gap: '1rem',
    border: `1px solid ${neutral['20']}`,
    '&.Mui-selected': {
      backgroundColor: neutral['10'],
      '&:hover': {
        backgroundColor: neutral['10'],
      },
    },
  },
  textMultiline: {
    margin: 0,
  },
  textPrimary: {
    marginBottom: '0.25rem',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: neutral[70],
  },
  textSecondary: {
    maxWidth: '40rem',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: neutral[100],
  },
  onOff: {
    width: '100%',
    maxWidth: 'max-content',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
});
